import removeIcon from '@disy/cadenza-icons/clear-round.svg';

import { AsyncEvent } from 'cadenza/map/async-event';
import { icon } from 'cadenza/utils/icon/icon';

import { LayerAction } from './layer-action';
import i18n from './layer-actions.properties';

export class RemoveLayer extends LayerAction {

  constructor (layer, options) {
    super(layer, Object.assign({
      icon: icon(removeIcon),
      label: i18n('mapConfig.removeLayer')
    }, options));
    this._map = options.map;
  }

  execute () {
    const confirmEvent = new AsyncEvent('preremove');
    this.layer.dispatchEvent(confirmEvent);
    return confirmEvent.getDefaultPreventedAsync().then(isPrevented => {
      if (!isPrevented) {
        this._map.removeLayer(this.layer);
      }
    });
  }

  isSupportedSync () {
    return true;
  }

}
